<!--分单管理-计划单发放-->
<template>
  <ls-table-layout>
    <div class="table-page-search-wrapper" slot="search">
      <ls-search-form @search="onSearch" @reset="resetQuery" :formList="formList" ref="refSearchForm">
        <global-select
          ref="listCategoryRef"
          slot="listCategory"
          :value.sync="queryParams.listCategory"
          selectType="selectMultipleSearch"
          requestApi="/scp/scpMpsPlansOrderFd/productBroadCategoryComboBox"
          :selectItem="{ value: 'realValue', label: 'label' }"
          :setParams="{}"
          searchParam="productBroadCategory"
        />
        <global-select
          ref="itemCodeListRef"
          slot="itemCodeList"
          :value.sync="queryParams.itemCodeList"
          selectType="selectMultipleSearch"
          :dropdown-match-select-width="false"
          requestApi="/mdm/mdmItemSystemItem/itemCodeBox"
          :selectItem="{ value: 'selectedValue', label: 'label' }"
          searchParam="itemCode"
          sourseField="res"
          :totalNum="9999999999"
        />
        <global-select
          ref="versionSelectRef"
          slot="version"
          :value.sync="queryParams.version"
          selectType="selectSearch"
          :dropdown-match-select-width="false"
          requestApi="/scp/scpMpsPlansOrderFd/versionComboBox"
          :selectItem="{ value: 'realValue', label: 'label' }"
          searchParam="version"
          :totalNum="9999999999"
        />
        <global-select
          ref="supplierCodeRef"
          slot="supplierCode"
          :max-tag-count="2"
          :max-tag-text-length="4"
          show-search
          :value.sync="queryParams.supplierCode"
          searchParam="supplierName"
          selectType="selectSearch"
          requestApi="/scp/scpSopMpsSupplierCapacityLoad/supplierPullDown"
          :dropdown-match-select-width="false"
          :selectItem="{ value: 'bringOutDataOne', label: 'selectedValue' }"
        />
        <global-select
          slot="statusList"
          :value.sync="queryParams.status"
          :selectData="statusList"
          selectType="selectFilter"
          :selectItem="{ value: 'lookupCode', label: 'lookupValue' }"
        />
        <a-select slot="fullMeetRemainSentDemandIs" v-model="queryParams.fullMeetRemainSentDemandIs" allowClear>
          <a-select-option :value="1">是</a-select-option>
          <a-select-option :value="0">否</a-select-option>
        </a-select>
        <a-range-picker slot="demandDate" v-model="queryParams.demandDate" valueFormat="YYYY-MM-DD" allowClear />
      </ls-search-form>
    </div>
    <div slot="btn">
      <a-space>
        <a-button :loading="loading" @click="onRefresh">计划单生成</a-button>
        <create-plan-modal ref="createPlanModalRef" @finallyUpdate="handleOk" />
        <a-button :loading="loading" @click="onRelease">发放计划单</a-button>
        <a-button :loading="loading" @click="onBatchEdit('demandDate')">调整交期</a-button>
        <a-button :loading="loading" @click="onBatchEdit('supplierCode')">调整供应商</a-button>
        <a-button :loading="loading" @click="onDistributionScope">发放范围</a-button>
        <a-button :loading="loading" @click="handleDel" type="danger" :disabled="selectedRows.length < 1">删除</a-button>
        <a-button type="primary" :loading="loading" @click="onExport">导出</a-button>
        <a-button type="primary" :loading="loading" @click="onImport">导入</a-button>
        <download-modal :apiFun="apiScpExportPlanOrder" ref="download" />
        <batch-edit-modal ref="batchEditModalRef" @finallyUpdate="handleOk" />
        <distribution-scope-modal ref="distributionScopeModalRef" @finallyWork="handleOk" />
        <import-excel
          ref="importExcelRef"
          :downloadParams="downloadParams"
          :uploadParams="upload"
          :customizeUpload="true"
          :uploadAboutRequest="uploadAboutRequest"
          @refresh="handleOk" />
      </a-space>
    </div>
    <template v-slot:table>
      <div class="page-header-content">
        <!-- 表格 -->
        <ls-api-table
          ref="dataTable"
          :columns="columns"
          :tableProps="tableProps"
          rowKey="id"
          :selectedRows.sync="selectedRows"
          :multi-select="true"
          @selectedRowChange="selectedRowChange"
          :scroll="{ fixScreen: true, x: 1400 }">
          <template slot="date" slot-scope="{ text }">
            <span>{{ text && $moment(text).format('YYYY-MM-DD') }}</span>
          </template>
        </ls-api-table>
      </div>
    </template>
  </ls-table-layout>
</template>

<script>
import { generateLsTableResData } from '@/utils/util.js'
import cloneDeep from 'lodash.clonedeep'
import batchEditModal from '@/views/finished-goods-order/allocation-result/plan-distribution/components/batch-edit-modal.vue'
import distributionScopeModal from '@/views/finished-goods-order/allocation-result/plan-distribution/components/distribution-scope-modal.vue'
import {
  apiScpFindPlansOrderFdPage,
  apiScpReleasePlanOrder,
  apiScpExportPlanOrder,
  apiScpDelPlanOrderFd
} from '@/api/finished-goods-order'
import DownloadModal from '@/views/components/download-modal/download-modal.vue'
import cacheRequest from '@/mixins/cacheRequest'
import ImportExcel from "@/views/finished-goods-order/base-data/supplier-process-ranking/components/importExcel"
import moment from 'moment'
import { METHOD, requestSet } from '@/utils/request'
import createPlanModal from "@/views/finished-goods-order/allocation-result/plan-distribution/components/create-plan-modal.vue"

export default {
  // eslint-disable-next-line
  name: 'Plan-distribution', // name要和rms配置菜单路由保存一致(首字母大写)
  components: { batchEditModal, distributionScopeModal, DownloadModal, ImportExcel, createPlanModal },
  mixins: [cacheRequest],
  data() {
    return {
      // 用户导入参数
      upload: {
        url: process.env.VUE_APP_API_BASE_URL + '/scp/scpMpsPlansOrderFd/importPlanOrder' // 上传的地址
      },
      // 导入模板下载参数
      downloadParams: {
        method: 'post',
        url: 'scp/scpMpsPlansOrderFd/template',
        name: `计划单发放导入模板_${moment().format('YYYY-MM-DD')}.xlsx`
      },
      uploadAboutRequest: {
        requestApi: '',
        errFileName: '计划单发放导入异常.xlsx'
      },
      currentDeliveryDateObj: [],
      loading: false,
      versionSelectList: [], // 版本号下拉选择框
      selectedRowKeys: [],
      selectedRows: [],
      statusList: [], // 状态
      apiScpExportPlanOrder,
      // 表格配置
      tableProps: {
        requestApi: generateLsTableResData(apiScpFindPlansOrderFdPage, false),
        pageCurrent: true
      },
      // 查询参数
      queryParams: {
        version: undefined,
        listCategory: undefined,
        itemCodeList: undefined,
        status: undefined,
        supplierCode: undefined,
        demandDate: undefined,
        demandDateStart: undefined,
        demandDateEnd: undefined
      },
      formList: [
        { label: '工艺大类', decorator: ['listCategory'], type: 'listCategory' },
        { label: '供应商', decorator: ['supplierCode'], type: 'supplierCode' },
        { label: '状态', decorator: ['status'], type: 'statusList' },
        { label: '版本', decorator: ['version'], type: 'version' },
        { label: '物料编码', decorator: ['itemCodeList'], type: 'itemCodeList' },
        { label: '需求交期', decorator: ['demandDate'], type: 'demandDate' }
      ],
      // 表格字段
      columns: [
        { title: '物料编码', dataIndex: 'itemCode', align: 'center', width: 130, stickyFixed: 'left' },
        { title: '物料名称', dataIndex: 'itemName', align: 'center', width: 130, ellipsis: true, stickyFixed: 'left' },
        { title: '规格描述', dataIndex: 'specification', align: 'center', width: 140, ellipsis: true, stickyFixed: 'left' },
        { title: '需求数量', dataIndex: 'demandQty', align: 'center', width: 90, stickyFixed: 'left' },
        { title: '需求交期', dataIndex: 'demandDate', align: 'center', width: 100, scopedSlots: { customRender: 'date' }, stickyFixed: 'left' },
        { title: '状态', dataIndex: 'statusName', align: 'center', width: 90, stickyFixed: 'left' },
        { title: '供应商名称', dataIndex: 'supplierName', align: 'center', width: 230 },
        { title: '供应商编码', dataIndex: 'supplierCode', align: 'center', width: 120 },
        { title: '工艺大类', dataIndex: 'productBroadCategoryName', align: 'center', width: 110 },
        { title: '是否停产', dataIndex: 'discontinuedFlagName', align: 'center', width: 90 },
        { title: '项目组', dataIndex: 'projectGroup', align: 'center', width: 130 },
        { title: '计划单', dataIndex: 'planOrderNumber', align: 'center', width: 140 },
        { title: '已签署数量', dataIndex: 'signedQuantity', align: 'center', width: 95 },
        { title: '已创建采购订单数量', dataIndex: 'requirementQuantity', align: 'center', width: 95 },
        { title: '计划单下发时间', dataIndex: 'orderIssuanceDate', align: 'center', width: 160 },
        { title: '采购单创建时间', dataIndex: 'poCreateTime', align: 'center', width: 160 },
        { title: '采购单签署时间', dataIndex: 'poSignTime', align: 'center', width: 160 },
        { title: '版本号', dataIndex: 'version', align: 'center', width: 120 },
        { title: '创建时间', dataIndex: 'createTime', align: 'center', width: 160 },
        { title: '创建人', dataIndex: 'createName', align: 'center', width: 90 },
        { title: '更新时间', dataIndex: 'updateTime', align: 'center', width: 160 },
        { title: '更新人', dataIndex: 'updateName', align: 'center', width: 90 }
      ]
    }
  },
  created() {
    this.cacheLookupRequest('SCP_MPS_FD_PLAN_ORDER_STATUS', { lookupType: 'SCP_MPS_FD_PLAN_ORDER_STATUS', current: 1, pageSize: 999 }, 'statusList')
  },
  mounted() {
    this.loading = false;
    this.onSearch()
  },
  methods: {
    // 导出
    onExport () {
      this.$message.loading('导出中..', 0.5)
      const params = this.$refs.dataTable.searchParams
      this.$refs.download.openModal(params)
    },
    // 导入
    onImport () {
      // 导入请求，带参数
      const apiImportPlanOrder = (params) => {
          return requestSet(`/scp/scpMpsPlansOrderFd/importPlanOrder?version=${this.queryParams?.version || ''}`, METHOD.POST, params, { responseType: "blob" });
      }
      this.uploadAboutRequest.requestApi = apiImportPlanOrder;
      this.$refs.importExcelRef.show()
    },
    // 刷新
    onRefresh() {
      this.$refs.createPlanModalRef.show();
    },
    // 发放计划单
    onRelease() {
      if(this.selectedRows?.length < 1) {
        return this.$message.warning("请勾选单据进行操作")
      }
      const grantData = this.selectedRows.filter(obj => obj.status !== 'N')
      if (grantData?.length > 0) {
        return this.$message.warning("请勾选未发放单据操作")
      }
      this.$confirm({
        title: '提示',
        content: '确定发放计划单？',
        okText: '确认',
        cancelText: '取消',
        onOk: () => {
          const params = {
            ids: this.selectedRowKeys
          }
          this.loading = true;
          apiScpReleasePlanOrder(params).then(res => {
            if (res?.code === 200) {
              this.$message.success('发放成功')
              this.onSearch()
            }
          }).finally(() => {
            this.loading = false;
          })
        }
      })
    },
    // 删除操作
    handleDel() {
      if(this.selectedRows?.length < 1) {
        return this.$message.warning("请勾选单据进行操作")
      }
      this.$confirm({
        title: '警告',
        content: `确认要删除已选择数据项吗?`,
        okText: '删除',
        okType: 'danger',
        cancelText: '取消',
        onOk: () => {
          const ids = this.selectedRows?.filter(obj => obj.status === 'N')?.map(obj => obj.id)
          if(ids?.length < 1) {
            this.$message.success('删除成功!')
            this.onSearch()
            return false
          }
          this.loading = true;
          apiScpDelPlanOrderFd(ids).then(res => {
            if (res?.code === 200) {
              this.$message.success('删除成功!')
              this.onSearch()
            } else {
              this.$message.error(res.msg)
            }
          }).finally(() => {
            this.loading = false;
          })
        }
      })
    },
    // 发送范围
    onDistributionScope() {
      this.$refs.distributionScopeModalRef.show();
    },
    // 批量修改
    onBatchEdit(field) {
      if(this.selectedRows?.length < 1) {
        return this.$message.warning("请勾选单据进行操作")
      }
      const grantData = this.selectedRows.filter(obj => obj.status !== 'N')
      if (grantData?.length > 0) {
        return this.$message.warning("请勾选未发放单据操作")
      }
      this.$refs.batchEditModalRef.show(field, cloneDeep(this.selectedRowKeys), cloneDeep(this.selectedRows));
    },
    // 行选中
    selectedRowChange (selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys;
      this.selectedRows = selectedRows;
    },
    // 表单搜索
    onSearch(value = {}) {
      const params = Object.assign({}, this.queryParams, value)
      delete params.searchFormLabel
      params.demandDateStart = params.demandDate && params.demandDate[0] ? (params.demandDate[0] + " 00:00:00") : undefined
      params.demandDateEnd = params.demandDate && params.demandDate[1] ? (params.demandDate[1] + " 23:59:59") : undefined
      delete params.demandDate
      this.$refs.dataTable.searchParams = cloneDeep(params)
      this.$refs.dataTable.getData()
    },
    // 新增/修改框事件
    handleOk() {
      this.onSearch()
    },
    // 重置按钮操作
    resetQuery() {
      this.queryParams = {
        version: undefined,
        listCategory: undefined,
        itemCodeList: undefined,
        status: undefined,
        supplierCode: undefined,
        demandDate: undefined,
        demandDateStart: undefined,
        demandDateEnd: undefined
      }
      this.$refs.dataTable.searchParams = this.queryParams
      this.$refs.refSearchForm.form.setFieldsValue(this.queryParams)
      this.$refs.versionSelectRef.handleSearch(''); // 版本
      this.$refs.itemCodeListRef.handleSearch('');
      this.$refs.listCategoryRef.handleSearch('');
      this.$refs.supplierCodeRef.handleSearch('');
    },
    // 导出
    handleExport() {
      const params = this.$refs.dataTable.searchParams
      this.$refs.download.openModal(params)
    }
  }
}
</script>

<style scoped lang="less"></style>
